import React, { PureComponent } from 'react';
import { PropTypes } from 'prop-types';
import { translate } from 'react-i18next';

import * as Common from 'common/components';

class ImportFormFilesPreview extends PureComponent {
  static propTypes = {
    file: PropTypes.shape({ id: PropTypes.string.isRequired, name: PropTypes.string.isRequired }),
    handleFileRemove: PropTypes.func.isRequired,
  };

  render = () => {
    let file = this.props.file;
    if (this.props.file && !this.props.file.name) file = null;
    return (
      <div className={'row'}>
        <Common.FilesTable
          files={file ? [this.props.file] : []}
          handleRemove={this.props.handleFileRemove}
        />
      </div>
    );
  };
}

export default translate()(ImportFormFilesPreview);



// WEBPACK FOOTER //
// src/modules/secured/modules/import/components/form/ImportFormFilesPreview.js